export default function(response) {
  return response.message ? response.message : 'Ooops something goes wrong';
}
